import { EnterpriseSsoConfig } from './environment.model';

// Enterprise SSO switch for deployed builds, fed by the build-time constants
// (see build-constants.d.ts). Shared by the deployed environment files.
export const deployedEnterpriseSso: EnterpriseSsoConfig = {
  enabled: SAML_ENABLED === 'true',
  providerId: SAML_PROVIDER_ID,
};
